import * as React from "react";
import { ChevronUp, ChevronDown, ChevronsUpDown } from "lucide-react";
import { cn } from "@/lib/utils.js";

/**
 * Reusable sortable table header component
 * @param {Object} props
 * @param {string} props.column - Column identifier
 * @param {string} props.sortColumn - Current sort column
 * @param {string} props.sortDirection - Current sort direction ("asc" | "desc")
 * @param {Function} props.onClick - Click handler
 * @param {React.ReactNode} props.children - Header content
 * @param {string} props.className - Additional CSS classes
 */
const SortableTableHeader = React.forwardRef(
  (
    { column, sortColumn, sortDirection, onClick, children, className },
    ref
  ) => {
    const getSortIcon = () => {
      if (sortColumn === column) {
        return sortDirection === "asc" ? (
          <ChevronUp className='h-4 w-4 ml-1 inline text-muted-foreground' />
        ) : (
          <ChevronDown className='h-4 w-4 ml-1 inline text-muted-foreground' />
        );
      }
      // Show neutral sort icon when column is sortable but not currently sorted
      return (
        <ChevronsUpDown className='h-4 w-4 ml-1 inline text-muted-foreground opacity-50' />
      );
    };

    return (
      <div
        ref={ref}
        className={cn("flex items-center", className)}
        onClick={onClick}
        style={onClick ? { cursor: "pointer" } : undefined}>
        {children}
        {getSortIcon()}
      </div>
    );
  }
);

SortableTableHeader.displayName = "SortableTableHeader";

export default SortableTableHeader;
